import queryString from 'query-string';
import { isNil, pickBy } from 'lodash';

// Unset params (undefined or null) are left out — see utils/custom/generateQSParams.
export default (params) => queryString.stringify(pickBy({ ...params }, (item) => !isNil(item)));
